import React from 'react';
import {PanGestureHandler} from "react-native-gesture-handler";
import Animated, {Easing, runOnJS, useAnimatedGestureHandler, useAnimatedStyle, useSharedValue, withTiming} from "react-native-reanimated";
import {Dimensions} from "react-native";


export default function BackGesture(props) {

    const { height } = Dimensions.get("window")
    const y = useSharedValue(0);

    const checkGoBack = () => {
        if (props.navigation.canGoBack()) {
            y.value = withTiming(height, {duration: 500, easing: Easing.out(Easing.exp)});
            props.navigation.goBack();
        } else {
            y.value = withTiming(0, {duration: 500, easing: Easing.out(Easing.exp)});
        }
    }

    const backEventHandler = useAnimatedGestureHandler({
        onActive: (event, ctx) => {
            y.value = event.translationY;
        },
        onEnd: (event, ctx) => {
            if (event.translationY >= (height / 2)) {
                runOnJS(checkGoBack)()
            } else {
                y.value = withTiming(0, {duration: 500, easing: Easing.out(Easing.exp)});
            }
        },
    });

    const styleAnimated = useAnimatedStyle(() => ({
        transform: [
            { translateY: y.value },
        ],
    }));

    return (
        <PanGestureHandler onHandlerStateChange={backEventHandler} activeOffsetY={20}>
            <Animated.View style={[{flex: 1}, styleAnimated]}>
                {props.children}
            </Animated.View>
        </PanGestureHandler>
    );
}